import type React from "react";

export interface BaseTabItem {
  ariaLabel?: string;
  badge?: string | number;
  disabled?: boolean;
  icon?: React.ReactNode;
  id: string | number;
  label: string;
  visible?: boolean | ((tab: BaseTabItem, allTabs: BaseTabItem[]) => boolean);
}

export function filterVisibleTabs<T extends BaseTabItem>(tabs: T[]): T[] {
  return tabs.filter((tab) => {
    if (tab.visible === undefined) {
      return true;
    }
    if (typeof tab.visible === "boolean") {
      return tab.visible;
    }
    if (typeof tab.visible === "function") {
      return tab.visible(tab, tabs);
    }
    return true;
  });
}

export function renderTabTriggerContent(tab: BaseTabItem): React.ReactNode {
  return (
    <>
      {tab.icon && <span className="mr-1.5">{tab.icon}</span>}
      {tab.label}
      {tab.badge !== undefined && (
        <span className="ml-1.5 rounded-full bg-primary/10 px-2 py-0.5 text-xs">
          {tab.badge}
        </span>
      )}
    </>
  );
}
